export const QBD_DESKTOP_EXPORTER_FILENAME = "DesktopExporter.exe";

export const ACCOUNTING_MIGRATION_CONNECTION_NOT_FOUND_MESSAGE =
    "Integration connection not found";
export const ACCOUNTING_MIGRATION_QUICKBOOKS_RECONNECT_REQUIRED_MESSAGE =
    "Reconnect QuickBooks Online before starting the migration.";

export const QBD_DESKTOP_EXPORTER_S3_BUCKETS = {
    production: "kick-production-public",
    develop: "kick-develop-public",
} as const;

export type QbdDesktopExporterEnvironment =
    keyof typeof QBD_DESKTOP_EXPORTER_S3_BUCKETS;

export function qbdDesktopExporterDownloadUrl(
    environment: QbdDesktopExporterEnvironment,
): string {
    const bucket = QBD_DESKTOP_EXPORTER_S3_BUCKETS[environment];
    return `https://${bucket}.s3.us-west-2.amazonaws.com/downloads/${QBD_DESKTOP_EXPORTER_FILENAME}`;
}

export enum DocumentMigrationErrorCode {
    PARSE_FAILED = "PARSE_FAILED",
    IMPORT_REJECTED = "IMPORT_REJECTED",
    ACCOUNT_CODE_MISMATCH = "ACCOUNT_CODE_MISMATCH",
    UNBALANCED_JOURNAL_ENTRIES = "UNBALANCED_JOURNAL_ENTRIES",
    OPENING_BALANCES_UNRECONCILED = "OPENING_BALANCES_UNRECONCILED",
    PERSIST_FAILED = "PERSIST_FAILED",
    BASIS_REQUIRED = "BASIS_REQUIRED",
    DOCUMENT_NOT_FOUND = "DOCUMENT_NOT_FOUND",
}

// Blocking issues gate completion; warning is modelled for future
// non-blocking issues but is not produced yet.
export enum DocumentMigrationIssueSeverity {
    BLOCKING = "blocking",
    WARNING = "warning",
}
